import { useRef } from "react";
import "./otp.less";

const OtpInput = ({ length = 6, onChange }) => {
  const refs = useRef([]);

  const handleInput = (e, i) => {
    const val = e.target.value.replace(/\D/g, "").slice(-1);
    e.target.value = val;
    if (val && i < length - 1) refs.current[i + 1]?.focus();
    fireChange();
  };

  const handleKeyDown = (e, i) => {
    if (e.key === "Backspace" && !e.target.value && i > 0) {
      refs.current[i - 1].value = "";
      refs.current[i - 1]?.focus();
    } else if (e.key === "ArrowLeft" && i > 0) {
      refs.current[i - 1]?.focus();
    } else if (e.key === "ArrowRight" && i < length - 1) {
      refs.current[i + 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, length);
    pasted.split("").forEach((ch, j) => {
      if (refs.current[j]) refs.current[j].value = ch;
    });
    refs.current[Math.min(pasted.length, length - 1)]?.focus();
    fireChange();
  };

  const fireChange = () => {
    const otp = refs.current.map((r) => r?.value || "").join("");
    onChange?.(otp);
  };

  return (
    <div className="otp-input-wrap">
      {Array.from({ length }).map((_, i) => (
        <input
          key={i}
          ref={(el) => (refs.current[i] = el)}
          className="otp-box"
          type="text"
          inputMode="numeric"
          maxLength={1}
          onInput={(e) => handleInput(e, i)}
          onKeyDown={(e) => handleKeyDown(e, i)}
          onPaste={handlePaste}
          autoComplete={i === 0 ? "one-time-code" : "off"}
        />
      ))}
    </div>
  );
};

export default OtpInput;
